import { PaperClipOutlined } from "@ant-design/icons";
import { Button, Modal, Upload } from "antd";
import TextArea from "antd/es/input/TextArea";
import { UploadFile } from "antd/lib";
import { FC } from "react";

import { PrimaryText } from "@/shared/ui/Typography";

import {
    StyledSPModalButtonConfirm,
    StyledSPModalControls,
    StyledSPTextarea,
} from "./Styled";

export const SKIP_POINT_FILES = [
    {
        uid: "0",
        name: "xxx.png",
        status: "uploading",
        percent: 33,
    },
];
interface SkipPointModalProps {
    isOpen: boolean;
    onClose: () => void;
}

export const SkipPointModal: FC<SkipPointModalProps> = ({
    isOpen,
    onClose,
}) => {
    return (
        <Modal
            title=""
            open={isOpen}
            onOk={onClose}
            onCancel={onClose}
            centered
            width="90%"
            footer={[]}
        >
            <PrimaryText
                fontSize={20}
                fontWeight="500"
                lineHeight="20px"
                textAlign="center"
                padding="0 0 16px 0"
            >
                Пропустити?
            </PrimaryText>
            <PrimaryText
                fontSize={16}
                lineHeight="20px"
                fontWeight="400"
                padding="16px 0"
            >
                Поясніть причину пропуску торгової точки
            </PrimaryText>
            <StyledSPTextarea>
                <TextArea rows={4} placeholder="Ваш коментар..." />
                <Upload
                    action="https://660d2bd96ddfa2943b33731c.mockapi.io/api/upload"
                    listType="picture"
                    defaultFileList={[...SKIP_POINT_FILES] as UploadFile[]}
                    className="upload-list-inline"
                >
                    <PaperClipOutlined
                        style={{ height: "20px", fontSize: "20px" }}
                    />
                </Upload>
            </StyledSPTextarea>
            <StyledSPModalControls>
                <StyledSPModalButtonConfirm>
                    Відправити
                </StyledSPModalButtonConfirm>

                <Button type="text" onClick={onClose}>
                    Назад
                </Button>
            </StyledSPModalControls>
        </Modal>
    );
};
